import { AppStatus, IPage } from '../../interfaces';

export const pagesPublic: IPage[] = [
    {
        id: '000-Init',
        componentName: 'Initialization',
        title: 'Initialization',
        url: '/',
        isActive: true,
        isDefault: true,
        appStatus: AppStatus.INITIALIZATION,
    },
    {
        id: '001-Login',
        componentName: 'Login',
        title: 'Login',
        url: '/login',
        isActive: true,
        isDefault: true,
        appStatus: AppStatus.AUTHORIZATION,
    },
    {
        id: '002-ResetPassword',
        componentName: 'ResetPassword',
        title: 'Reset Password',
        url: '/reset_password',
        isActive: true,
        isDefault: false,
        appStatus: AppStatus.AUTHORIZATION,
    },
    {
        id: '004-SignUp',
        componentName: 'SignUp',
        title: 'SignUp',
        url: '/signup',
        isActive: false,
        isDefault: false,
        appStatus: AppStatus.AUTHORIZATION,
    },
    // Private page
    // {
    //     id: '0000-Terms',
    //     appSystem: AppSystem.OCS,
    //     componentName: 'Terms',
    //     title: 'Terms',
    //     url: '/terms',
    //     isActive: false,
    //     isDefault: false,
    //     appStatus: 'ACCEPT_POLICY',
    // },
];
